var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.75 20 2 2H6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 6 2h9l5 6v12c0 .333-.07.637-.212.913a1.948 1.948 0 0 1-.588.687L14 16.45c-.283.183-.592.32-.925.413A4.04 4.04 0 0 1 12 17c-1.1 0-2.042-.392-2.825-1.175C8.392 15.042 8 14.1 8 13s.392-2.042 1.175-2.825C9.958 9.392 10.9 9 12 9s2.042.392 2.825 1.175C15.608 10.958 16 11.9 16 13c0 .383-.046.742-.137 1.075-.092.333-.23.642-.413.925L18 17.6V8.7L14.05 4H6v16h8.75ZM12 15c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 11c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 13c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b7438a97f312cd280c481dbc0c07abfa.svg";
export { ForwardRef as ReactComponent };